import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shop/[slug]/ShopProductPageClient.tsx");
